module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062839312_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rtitle"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062839312_Titlepage#title"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062839312_Dedication#_idParaDest-1"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062839312_Epigraph#_idParaDest-2"
    }
  }, [_c('i', [_vm._v("Epigraph")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/9780062839312_Contents"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('i', [_vm._v("Contents")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "r_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062839312_Prologue#_idParaDest-4"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "r_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062839312_Part_1#_idParaDest-5"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_1#_idParaDest-6"
    }
  }, [_vm._v("1: Marco Made Me Do It ~ North America")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-9"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_2#_idParaDest-9"
    }
  }, [_vm._v("2: Roof of the World ~ Tibetan Plateau")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-12"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_3#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Natural History ~ England and New England")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "r_idParaDest-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Part_2#_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-16"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_4#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Undercurrents ~ Black Sea")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-19"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_5#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: The Cold World Awakens ~ Lesser Caucasus")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-22"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_6#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Angle of Incidence ~ Greater Caucasus")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-25"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_7#_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Borderlandia ~ Caspian Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "r_idParaDest-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Part_3#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-29"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_8#_idParaDest-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Wilderness/Wasteland ~ Ustyurt Plateau and Aral Sea Basin")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-32"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_9#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: The Source of a River ~ Pamir Knot")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "r_idParaDest-35"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_10#_idParaDest-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: A Mote of Dust Suspended in a Sunbeam ~ Tarim Basin and Tibetan Plateau")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "r_idParaDest-38"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062839312_Chapter_11#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: Road’s End ~ Indo-Gangetic Plain and Greater Himalaya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "r_idParaDest-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Epilogue#_idParaDest-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "r_idParaDest-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Acknowledgments#_idParaDest-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Permissions#_idParaDest-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Permissions")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Selected_Bibliography#_idParaDest-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062839312_Copyright#_idParaDest-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "r_idParaDest-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])])])])])])])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e061e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062839312_Contents.vue
// module id = 69
// module chunks = 0